<template>
  <div>
    <span class="vgt-loading__content">
      {{message}}
    </span>
  </div>
</template>

<script>


  export default {
    name: "TableLoading",
    data () {
      return {
        message: 'Cargando ...' 
      }
    },
    props: { 
    },
    methods: {
    }
  }
</script>

<style scoped>

</style>